import { Category } from './category.model';

export class CategoryMapper {
  public static map(categoryData: any): Category {
    if (!categoryData) {
      return null;
    }

    return new Category (
        categoryData.id,
        categoryData.name,
        categoryData.slug
      );
  }
}



// WEBPACK FOOTER //
// /dist/src/app/question/category.mapper.ts